if (!customElements.get('countdown-bar')) {
  class CountdownBar extends HTMLElement {
    connectedCallback() {
      const endDate = new Date(this.dataset.countdownEnd);

      if (Number.isNaN(endDate.getTime()) || endDate.getTime() <= Date.now()) {
        this.remove();
        return;
      }

      this.addEventListener('countdown:expired', () => {
        this.remove();
        // rea-header-scroll.js sums every .utility-bar's rendered height
        // into the transparent header's offset on load/resize only - this
        // bar can disappear mid-session (unlike the popup, unlike the
        // always-present announcement bar), so its own resize listener is
        // reused to re-measure rather than duplicating that logic here.
        window.dispatchEvent(new Event('resize'));
      });

      this.removeAttribute('hidden');
      // Reveals after rea-header-scroll.js's own initial offset measurement
      // (that script loads earlier in <head>, this one is deferred from
      // inside the section markup itself) - without this, the transparent
      // header would sit above this bar's height on first load.
      window.dispatchEvent(new Event('resize'));
    }
  }

  customElements.define('countdown-bar', CountdownBar);
}
